import React, { Component } from 'react';

import AsyncSelect from 'react-select/lib/Async';
import "./select.css";
import Requisitions from '../../utils/requisitions/Requisitions';
import FilterData from '../../utils/strings/FilterData';
//https://github.com/jedwatson/react-select

class SelectAjax extends Component{
	constructor (props){
		super(props);

		this.state = { inputValue: '', url: props.url };

		this.handleInputChange = this.handleInputChange.bind(this);
		this.makeRequest = this.makeRequest.bind(this);
	}

  handleInputChange = (newValue: string) => {
  };

	makeRequest = function(inputValue,callback){

		var _url = this.state.url;
		var _self = this;
		var _formData=  new FormData();

		_formData.append("nome",inputValue);

		const addSearch = this.props.data;

		if(addSearch){
			Object.keys(addSearch).forEach(function(key) {
				_formData.append(key,addSearch[key]);
			});
		}

		Requisitions({
			url:_url,
			data:_formData,
			sucess:function(data){
				const itens = FilterData(inputValue,data);
				callback(itens);
			},
			error:function(data){
				console.log(data);
			}
		});

	}

  render() {
		const {url} = this.state;
    return (
      <div className="box-input">
          <div className="box-input--title">{this.props.title}</div>
          <div className="box-input--select">
            <AsyncSelect
							noResultsText = {this.props.noResultsText}
							name = {this.props.name}
							onChange={this.props.onChange}
							autoload={this.props.autoload}
							loadingPlaceholder='Carregando...'
							loadOptions={this.makeRequest}
							 />
          </div>
      </div>
    );
  }
}

export default SelectAjax;



// WEBPACK FOOTER //
// ./src/components/form/SelectAjax.js